"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _getEarlyRequesterResultPromise = _interopRequireDefault(require("../getEarlyRequesterResultPromise"));

var API_BASE = 'content-settings/v1/site-settings/by-portal-id';

var SiteSettingsAPI =
/*#__PURE__*/
function () {
  function SiteSettingsAPI() {
    (0, _classCallCheck2.default)(this, SiteSettingsAPI);
  }

  (0, _createClass2.default)(SiteSettingsAPI, null, [{
    key: "getSiteSettings",
    value: function getSiteSettings() {
      return (0, _getEarlyRequesterResultPromise.default)('site-settings') || _apiClient.default.get(API_BASE + "/" + _hubspot.default.get());
    }
  }, {
    key: "updateSiteSettings",
    value: function updateSiteSettings(options) {
      return _apiClient.default.put(API_BASE + "/" + _hubspot.default.get(), {
        data: (0, _extends2.default)({}, options)
      });
    }
  }, {
    key: "updateSiteSettingsOverrides",
    value: function updateSiteSettingsOverrides(data) {
      return _apiClient.default.put(API_BASE + "/" + _hubspot.default.get() + "/overrides", {
        data: data
      });
    }
  }, {
    key: "updateSiteSettingsMergeTags",
    value: function updateSiteSettingsMergeTags(options) {
      return _apiClient.default.put(API_BASE + "/" + _hubspot.default.get() + "/merge-tag-defaults", {
        data: (0, _extends2.default)({}, options)
      });
    }
  }, {
    key: "updateColorPickerFavorites",
    value: function updateColorPickerFavorites(options) {
      return _apiClient.default.put(API_BASE + "/" + _hubspot.default.get() + "/color-picker-favorites", {
        data: (0, _extends2.default)({}, options)
      });
    }
  }]);
  return SiteSettingsAPI;
}();

exports.default = SiteSettingsAPI;
module.exports = exports.default;